import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";

export const STANDARD_UIDS = {
  [CURRICULUM_TYPE_PYP]: "benchmarks",
  [CURRICULUM_TYPE_UBD]: "learningStandardUBD",
  [CURRICULUM_TYPE_MYP]: "learningStandardMYP",
  [CURRICULUM_TYPE_DP]: "subjectStandardDP",
};
